export default "__VITE_ASSET__1c53534f__"